import { h } from "preact";

/**
 * Opens the swatch request drawer. Behaviour lives in the `swatch-request-trigger`
 * custom element (components/swatch-modal), so the same trigger can be rendered
 * from Liquid.
 */
export default function SwatchRequestTrigger({ productUrl }) {
  if (!productUrl) return null;

  return (
    <swatch-request-trigger
      class="swatch-request-trigger"
      product-url={productUrl}
    >
      <button type="button" className="link link--x-small">
        {window.localeStrings.swatchModal.request_a_swatch}
      </button>
    </swatch-request-trigger>
  );
}
